export default {
    SET_HOLIDAYS: (state, payload) => {
        state.holidays = payload;
    },
    SET_HOLIDAY_TO_EDIT: (state, payload) => {
        state.holidayToEdit = payload;
    },
}